export default [{
    id: "12345",
    name: "Test Site",
}, ];